// @flow
import axios from 'axios';

import config from 'config';

const { apiEndPoint } = config;
export const instance = axios.create({
    baseURL: apiEndPoint,
});
